import {
  GET_PBL_P5,
  GET_PBL_P5_SUCCESS,
  GET_PBL_P5_FAILURE,
  GET_PBL_PROJECT_TYPES,
  GET_PBL_PROJECT_TYPES_SUCCESS,
  GET_PBL_PROJECT_TYPES_FAILURE,
  GET_PBL_PROJECTS,
  GET_PBL_PROJECTS_SUCCESS,
  GET_PBL_PROJECTS_FAILURE,
  CREATE_PBL_PROJECT,
  CREATE_PBL_PROJECT_SUCCESS,
  CREATE_PBL_PROJECT_FAILURE,
  UPDATE_PBL_PROJECT,
  UPDATE_PBL_PROJECT_SUCCESS,
  UPDATE_PBL_PROJECT_FAILURE,
  GET_PBL_PROJECTS_ID,
  GET_PBL_PROJECTS_ID_SUCCESS,
  GET_PBL_PROJECTS_ID_FAILURE,
  GET_CLASS_COURSES,
  GET_CLASS_COURSES_SUCCESS,
  GET_CLASS_COURSES_FAILURE,
  GET_COURSE_TEACHERS,
  GET_COURSE_TEACHERS_SUCCESS,
  GET_COURSE_TEACHERS_FAILURE,
} from '../../actions/PBL/types';

const initialState = {
  p5: {
    data: [],
    loading: false,
    error: null,
  },
  projectTypes: {
    data: [],
    loading: false,
    error: null,
  },
  project_detail: {
    data: null,
    loading: false,
    error: null,
  },
  projects: {
    data: [],
    loading: false,
    error: null,
  },
  classCourses: {
    data: [],
    loading: false,
    error: null,
  },
  courseTeachers: {
    data: [],
    loading: false,
    error: null,
  },
};

const pblReducer = (state = initialState, action) => {
  switch (action.type) {
    // P5 Assessment cases
    case GET_PBL_P5:
      return {
        ...state,
        p5: {
          ...state.p5,
          loading: true,
          error: null,
        },
      };
    case GET_PBL_P5_SUCCESS:
      return {
        ...state,
        p5: {
          ...state.p5,
          loading: false,
          data: action.payload,
        },
      };
    case GET_PBL_P5_FAILURE:
      return {
        ...state,
        p5: {
          ...state.p5,
          loading: false,
          error: action.payload,
        },
      };

    // Project Types cases
    case GET_PBL_PROJECT_TYPES:
      return {
        ...state,
        projectTypes: {
          ...state.projectTypes,
          loading: true,
          error: null,
        },
      };
    case GET_PBL_PROJECT_TYPES_SUCCESS:
      return {
        ...state,
        projectTypes: {
          ...state.projectTypes,
          loading: false,
          data: action.payload,
        },
      };
    case GET_PBL_PROJECT_TYPES_FAILURE:
      return {
        ...state,
        projectTypes: {
          ...state.projectTypes,
          loading: false,
          error: action.payload,
        },
      };

    // Projects cases
    case GET_PBL_PROJECTS:
      return {
        ...state,
        projects: {
          ...state.projects,
          loading: true,
          error: null,
        },
      };
    case GET_PBL_PROJECTS_SUCCESS:
      return {
        ...state,
        projects: {
          ...state.projects,
          loading: false,
          data: action.payload,
        },
      };
    case GET_PBL_PROJECTS_FAILURE:
      return {
        ...state,
        projects: {
          ...state.projects,
          loading: false,
          error: action.payload,
        },
      };

    // Create Project cases
    case CREATE_PBL_PROJECT:
      return {
        ...state,
        projects: {
          ...state.projects,
          loading: true,
          error: null,
        },
      };
    case CREATE_PBL_PROJECT_SUCCESS:
      return {
        ...state,
        projects: {
          ...state.projects,
          loading: false,
          data: [...state.projects.data, action.payload],
        },
      };
    case CREATE_PBL_PROJECT_FAILURE:
      return {
        ...state,
        projects: {
          ...state.projects,
          loading: false,
          error: action.payload,
        },
      };

    // Update Project cases
    case UPDATE_PBL_PROJECT:
      return {
        ...state,
        projects: {
          ...state.projects,
          loading: true,
          error: null,
        },
      };
    case UPDATE_PBL_PROJECT_SUCCESS:
      return {
        ...state,
        projects: {
          ...state.projects,
          loading: false,
          data: state.projects.data.map((item) => (item.id === action.payload.id ? action.payload : item)),
        },
      };
    case UPDATE_PBL_PROJECT_FAILURE:
      return {
        ...state,
        projects: {
          ...state.projects,
          loading: false,
          error: action.payload,
        },
      };

    // Get Project Detail cases
    case GET_PBL_PROJECTS_ID:
      return {
        ...state,
        project_detail: {
          ...state.project_detail,
          loading: true,
          error: null,
        },
      };
    case GET_PBL_PROJECTS_ID_SUCCESS:
      return {
        ...state,
        project_detail: {
          ...state.project_detail,
          loading: false,
          data: action.payload,
        },
      };
    case GET_PBL_PROJECTS_ID_FAILURE:
      return {
        ...state,
        project_detail: {
          ...state.project_detail,
          loading: false,
          error: action.payload,
        },
      };

    // Get Class Courses cases
    case GET_CLASS_COURSES:
      return {
        ...state,
        classCourses: {
          ...state.classCourses,
          loading: true,
          error: null,
        },
      };
    case GET_CLASS_COURSES_SUCCESS:
      return {
        ...state,
        classCourses: {
          ...state.classCourses,
          loading: false,
          data: action.payload,
        },
      };
    case GET_CLASS_COURSES_FAILURE:
      return {
        ...state,
        classCourses: {
          ...state.classCourses,
          loading: false,
          error: action.payload,
        },
      };

    // Get Course Teachers cases
    case GET_COURSE_TEACHERS:
      return {
        ...state,
        courseTeachers: {
          ...state.courseTeachers,
          loading: true,
          error: null,
        },
      };
    case GET_COURSE_TEACHERS_SUCCESS:
      return {
        ...state,
        courseTeachers: {
          ...state.courseTeachers,
          loading: false,
          data: action.payload,
        },
      };
    case GET_COURSE_TEACHERS_FAILURE:
      return {
        ...state,
        courseTeachers: {
          ...state.courseTeachers,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default pblReducer;
